<template>
  <div class="purchase-tabs">
    <div 
      v-for="tab in tabs" 
      :key="tab.value"
      :class="['tab-item', { active: activeTab === tab.value }]"
      @click="handleTabClick(tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseTabs',
  props: {
    activeTab: {
      type: String,
      default: 'all'
    },
    tabs: {
      type: Array,
      default: () => [
        { label: '全部订单', value: 'all' },
        { label: '已上传合同', value: 'uploaded' },
        { label: '待回传合同', value: 'waitBack' },
        { label: '待打款', value: 'waitPay' },
        { label: '待发货', value: 'waitDeliver' },
        { label: '已发货', value: 'delivered' },
        { label: '已签收', value: 'signed' },
        { label: '待开票', value: 'waitInvoice' },
        { label: '已完成', value: 'completed' },
      ]
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit('change', tab);
    }
  }
};
</script>

<style scoped lang="less">
.purchase-tabs {
  display: flex;
  border-bottom: 1px solid #E4E7ED;
  padding: 0 20px;
  
  .tab-item {
    padding: 15px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    position: relative;
    
    &:hover {
      color: #48A09C;
    }
    
    &.active {
      color: #48A09C;
      font-weight: 500;
      
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: #48A09C;
      }
    }
  }
}
</style>
